module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort1-2e2495e0ea56849d389515eb39a2ed50.svg";